var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_shared.js
// module id = 200
// module chunks = 0 1 2 3 4